import request from '@/common/request'
import { AxiosRequestConfig } from 'axios'

export interface DreMargemBruta {
	contaId: string
	lojaId: string
	loja: string
	competencia: string | null
	receitaBruta: number
	descontos: number
	devolucoes: number
	receitaLiquida: number
	impostos: number
	cmv: number
	lucroBruto: number
	pecas: number
	margemPct: number
	pctVendaSemCusto: number
	pctVendaCustoFallback: number
}

export interface RelatorioDeMargemBruta {
	linhas: DreMargemBruta[]
	consolidado: DreMargemBruta | null
}

export interface FiltroDeDre {
	lojas?: string[]
	mesInicio: string // YYYY-MM
	mesFim: string    // YYYY-MM
}

export const getMargemBruta = (params: FiltroDeDre, config?: AxiosRequestConfig): Promise<RelatorioDeMargemBruta> =>
	request.get('/dre/margem-bruta', { params, ...config })

// ----- Despesas fixas recorrentes -----

export interface DespesaFixaVigencia { id: string; valor: number; mesInicio: string }
export interface DespesaFixa {
	id: string
	contaId: string
	lojaId: string
	loja: string
	grupo: string
	descricao: string
	ativo: boolean
	vigencias: DespesaFixaVigencia[]
}
export interface DespesaFixaMensal { lojaId: string; competencia: string; grupo: string; descricao: string; valor: number; loja: string }
export interface DespesaFixaForm { lojaId?: string; grupo?: string; descricao?: string; valor: number; mesInicio: string }

export const listarDespesasFixas = (lojas?: string[]): Promise<DespesaFixa[]> =>
	request.get('/dre/despesas-fixas', { params: { lojas } })

export const getDespesasFixasMensal = (mesInicio: string, mesFim: string, lojas?: string[]): Promise<DespesaFixaMensal[]> =>
	request.get('/dre/despesas-fixas/mensal', { params: { mesInicio, mesFim, lojas } })

export const criarDespesaFixa = (form: DespesaFixaForm): Promise<string> =>
	request.post('/dre/despesas-fixas', form)

export const definirVigencia = (id: string, form: DespesaFixaForm): Promise<void> =>
	request.put(`/dre/despesas-fixas/${id}/vigencia`, form)

export const excluirDespesaFixa = (id: string): Promise<void> =>
	request.delete(`/dre/despesas-fixas/${id}`)

// ----- Despesas variáveis (contas a pagar) -----

export interface DespesaVariavelMensal { lojaId: string; competencia: string; grupo: string; valor: number; loja: string }

export const getDespesasVariaveisMensal = (mesInicio: string, mesFim: string, lojas?: string[]): Promise<DespesaVariavelMensal[]> =>
	request.get('/dre/despesas-variaveis/mensal', { params: { mesInicio, mesFim, lojas } })
